import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import moment from 'moment-timezone';
import { WithLoaderWrapper } from 'ziphy-web-shared/basic/lib/loaders';
import { formatDate } from 'ziphy-web-shared/basic/utils/time';
import { $calendar } from '@nedoShared/modules/calendar/Calendar.store';
import TableColumn from '@nedoShared/modules/calendar/table/tableColumn/TableColumn';
import TimeGrid from '@nedoShared/modules/calendar/table/timeGrid/TimeGrid';
import styles from './DashboardCalendar.module.scss';
const DashboardCalendar = () => {
    var _a;
    const now = moment.tz($calendar.timezone);
    const today = now.clone().startOf('day');
    const ref = useRef(null);
    const prevHeight = useRef();
    const [scheduledCount, setScheduledCount] = useState(0);
    useEffect(() => {
        if (!ref.current || $calendar.isLoading)
            return;
        prevHeight.current = ref.current.clientHeight;
        if (window.scrollY === 0 && $calendar.loadCount <= 1) {
            const timeline = document.querySelector('#schedule-timeline');
            if (timeline)
                window.scrollTo({ top: timeline.offsetTop });
        }
    }, [$calendar.isLoading]);
    const selectedDayKey = moment($calendar.selectedDay).format('YYYY-MM-DD');
    const daySlots = ((_a = $calendar.slots) === null || _a === void 0 ? void 0 : _a[selectedDayKey]) || [];
    const hasShifts = daySlots.some((s) => { var _a; return (((_a = s === null || s === void 0 ? void 0 : s.shiftIds) === null || _a === void 0 ? void 0 : _a.length) || 0) > 0; });
    useEffect(() => {
        if (!$calendar.appointments) {
            setScheduledCount(0);
            return;
        }
        const localTZ = $calendar.timezone;
        const selectedDayMoment = moment.tz($calendar.selectedDay, localTZ);
        const count = Object.values($calendar.appointments).filter((a) => {
            const start = moment.tz(a.appointedStart, localTZ);
            return start.isSame(selectedDayMoment, 'day');
        }).length;
        setScheduledCount(count);
    }, [$calendar.appointments, $calendar.selectedDay]);
    return (_jsxs("div", Object.assign({ className: styles.table }, { children: [_jsx("div", Object.assign({ className: styles.date }, { children: moment($calendar.selectedDay).isSame(now, 'day')
                    ? `Today, ${formatDate(now, 'dateNoYear')}`
                    : formatDate($calendar.selectedDay, {
                        format: !moment($calendar.selectedDay).isSame(now, 'year')
                            ? 'dateFull'
                            : 'dateNoYear',
                    }) })), _jsx("div", Object.assign({ className: styles.scheduled }, { children: scheduledCount > 0
                    ? `${scheduledCount} telehealth visits scheduled`
                    : `No scheduled visits` })), _jsx("div", Object.assign({ className: classNames(styles.shifts, { [styles.disabled]: !hasShifts }) }, { children: _jsxs(WithLoaderWrapper, Object.assign({ isLoading: $calendar.isLoading, loader: 'empty', className: classNames(styles.tableContent, styles.padding) }, { children: [_jsx(TimeGrid, { className: styles.padding, isShowTimeline: moment($calendar.selectedDay).isSame(now, 'day') }), _jsx("div", Object.assign({ ref: ref, className: classNames(styles.inner, styles.isDay), style: { height: $calendar.isLoading && prevHeight.current } }, { children: Object.keys($calendar.schedule)
                                .filter((date) => moment(date).isSame($calendar.selectedDay, 'day'))
                                .map((date) => (_jsx(TableColumn, { date: date, data: $calendar.schedule[date] }, date))) }))] })) }))] })));
};
export default observer(DashboardCalendar);
